import React from "react";
import { Box, FormControlLabel, Switch, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { WizardStepProps } from "@components/WizardCst/types";
import { ActivityWizardData } from "../../../types";
import ToggleSection from "./ToggleSection";

const MobileFruitionSection: React.FC<WizardStepProps<ActivityWizardData>> = ({
  data,
  setData,
}) => {
  const { t } = useTranslation("wizard-activity");
  const theme = useTheme();

  const showDownloadFlag = data.type === "DA_EXTERNAL_RES";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <ToggleSection
        question={t("sections.mobile.question")}
        description={t("sections.mobile.description") || undefined}
        checked={data.fruition_flag}
        onChange={(next) => setData({ fruition_flag: next })}
        noLabel={t("common.no") || "No"}
        yesLabel={t("common.yes") || "Sì"}
      />

      {showDownloadFlag && (
        <FormControlLabel
          sx={{ color: theme.palette.text.primary, ml: 0 }}
          control={
            <Switch
              checked={data.download_flag}
              onChange={(_, checked) => setData({ download_flag: checked })}
            />
          }
          label={t("sections.mobile.allow-download") || "Consenti download"}
        />
      )}
    </Box>
  );
};

export default MobileFruitionSection;
